import React from 'react'
import styled from 'styled-components'
import Carousel from 'react-bootstrap/Carousel';

const TopBrandsImages = () => {
  const redirecturl = (url) => {
    window.open(url, "_blank", "noopener,noreferrer")
  }

  return (
    <Wrapper>
      <div className='container'>
        <div className='row align-items-stretch'>
          <div className='col-12 d-none d-md-block'>
            <div>
              <Carousel interval={3000} pause={false} controls={false}>
                <Carousel.Item>
                  <div className="row p-2">
                    {[{
                        logo: "air-india-logo.jpg",
                        url: "https://www.airindia.com",
                      },
                      {
                        logo: "amazon-logo.jpg",
                        url: "https://www.amazon.in",
                      },
                      {
                        logo: "myntra-logo.jpg",
                        url: "https://www.myntra.com",
                      },
                      {
                        logo: "flipkart-logo.jpg",
                        url: "https://www.flipkart.com",
                      },
                      {
                        logo: "dell-logo.jpg",
                        url: "https://www.dell.com",
                      },
                      {
                        logo: "ajio-logo.jpg",
                        url: "https://www.ajio.com",
                      },{
                        logo: "uber-logo.jpg",
                        url: "https://www.uber.com/in/en/ride/?ad_id=614919360179&adg_id=143634984230&campaign_id=17954041642&cre=614919360179&dev=c&dev_m=&fi_id=&gad_campaignid=17954041642&gad_source=1&gbraid=0AAAAADiA3jqyyIsJOsYEunEhYwA2ge3ZY&gclid=EAIaIQobChMIh5Tg44mQkgMVv6hmAh0fICrUEAAYASAAEgKjk_D_BwE&gclsrc=aw.ds&kw=uber&kwid=kwd-12633382&match=b&net=g&placement=&tar=&utm_campaign=CM2197857-search-google-brand_77_-99_IN-National_r_web_acq_cpc_en_T1_Generic_BM_uber_kwd-12633382_614919360179_143634984230_b_c&utm_source=AdWords_Brand",
                      },
                      {
                        logo: "makemytrip-logo.jpg",
                        url: "https://www.makemytrip.com",
                      },
                      {
                        logo: "udemy-logo.jpg",
                        url: "https://www.udemy.com",
                      },
                      {
                        logo: "samsung-logo.jpg",
                        url: "https://www.samsung.com",
                      },
                      {
                        logo: "bigrock-logo.png",
                        url: "https://www.bigrock.in",
                      },
                      {
                        logo: "nykaa-logo.jpg",
                        url: "https://www.nykaa.com",
                      },
                    ].map((logo, i) => (
                      <div key={i} className="col-4 col-md-3 p-1">
                        <div className="logo-box border">
                          <img src={`./images/${logo.logo}`} className="logo-img" alt="" onClick={()=>redirecturl(logo.url)} style={{cursor:'pointer'}}  />
                        </div>
                      </div>
                    ))}
                  </div>
                </Carousel.Item>
                <Carousel.Item>
                  <div className="row p-2">
                    {[{
                      logo: "bookmyshow-logo.jpg",
                      url: "https://in.bookmyshow.com",
                    },
                    {
                      logo: "puma-shop-logo.jpg",
                      url: "https://in.puma.com",
                    },
                    {
                      logo: "etihad-airways-logo.jpg",
                      url: "https://www.etihad.com",
                    },
                    {
                      logo: "boat-logo.jpg",
                      url: "https://www.boat-lifestyle.com",
                    },
                    {
                      logo: "handm-logo.jpg",
                      url: "https://www2.hm.com",
                    },
                    {
                      logo: "godaddy-logo.jpg",
                      url: "https://www.godaddy.com",
                    },{
                      logo: "oneplus-logo.jpg",
                      url: "https://www.oneplus.in",
                    },
                    {
                      logo: "muscleblaze-logo.jpg",
                      url: "https://www.muscleblaze.com",
                    },
                    {
                      logo: "croma-logo.jpg",
                      url: "https://www.croma.com",
                    },
                    {
                      logo: "lenskart-logo.jpg",
                      url: "https://www.lenskart.com",
                    },
                    {
                      logo: "adidas-logo.jpg",
                      url: "https://www.adidas.co.in",
                    },
                    {
                      logo: "dominos-logo.jpg",
                      url: "https://www.dominos.co.in",
                    },
                    ].map((logo, i) => (
                      <div key={i} className="col-4 col-md-3 p-1">
                        <div className="logo-box border">
                          <img src={`./images/${logo.logo}`} className="logo-img" alt="" onClick={()=>redirecturl(logo.url)} style={{cursor:'pointer'}}  />
                        </div>
                      </div>
                    ))}
                  </div>
                </Carousel.Item>
              </Carousel>
            </div>
          </div>
          <div className='col-12 d-block d-md-none'>
            <div>
              <Carousel interval={3000} pause={false} controls={false}>
                <Carousel.Item>
                  <div className="row p-2">
                    {[
                      {
                        logo: "air-india-logo.jpg",
                        url: "https://www.airindia.com",
                      },
                      {
                        logo: "amazon-logo.jpg",
                        url: "https://www.amazon.in",
                      },
                      {
                        logo: "myntra-logo.jpg",
                        url: "https://www.myntra.com",
                      },
                      {
                        logo: "flipkart-logo.jpg",
                        url: "https://www.flipkart.com",
                      },
                      {
                        logo: "dell-logo.jpg",
                        url: "https://www.dell.com",
                      },
                      {
                        logo: "ajio-logo.jpg",
                        url: "https://www.ajio.com",
                      },
                    ].map((logo, i) => (
                      <div key={i} className="col-4 col-md-3 p-1">
                        <div className="logo-box border">                      
                            <img src={`./images/${logo.logo}`} className="logo-img" alt="" onClick={()=>redirecturl(logo.url)} style={{cursor:'pointer'}} />
                        </div>
                      </div>
                    ))}
                  </div>
                </Carousel.Item>
                <Carousel.Item>
                  <div className="row p-2">
                    {[{
                      logo: "bookmyshow-logo.jpg",
                      url: "https://in.bookmyshow.com",
                    },
                    {
                      logo: "puma-shop-logo.jpg",
                      url: "https://in.puma.com",
                    },
                    {
                      logo: "etihad-airways-logo.jpg",
                      url: "https://www.etihad.com",
                    },
                    {
                      logo: "boat-logo.jpg",
                      url: "https://www.boat-lifestyle.com",
                    },
                    {
                      logo: "handm-logo.jpg",
                      url: "https://www2.hm.com",
                    },
                    {
                      logo: "godaddy-logo.jpg",
                      url: "https://www.godaddy.com",
                    },
                    ].map((logo, i) => (
                      <div key={i} className="col-4 col-md-3 p-1">
                        <div className="logo-box border">                        
                            <img src={`./images/${logo.logo}`} className="logo-img" alt="" onClick={()=>redirecturl(logo.url)} style={{cursor:'pointer'}} />
                        </div>
                      </div>
                    ))}
                  </div>
                </Carousel.Item>
                <Carousel.Item>
                  <div className="row p-2">
                    {[
                      {
                        logo: "uber-logo.jpg",
                        url: "https://www.uber.com/in/en/ride/?ad_id=614919360179&adg_id=143634984230&campaign_id=17954041642&cre=614919360179&dev=c&dev_m=&fi_id=&gad_campaignid=17954041642&gad_source=1&gbraid=0AAAAADiA3jqyyIsJOsYEunEhYwA2ge3ZY&gclid=EAIaIQobChMIh5Tg44mQkgMVv6hmAh0fICrUEAAYASAAEgKjk_D_BwE&gclsrc=aw.ds&kw=uber&kwid=kwd-12633382&match=b&net=g&placement=&tar=&utm_campaign=CM2197857-search-google-brand_77_-99_IN-National_r_web_acq_cpc_en_T1_Generic_BM_uber_kwd-12633382_614919360179_143634984230_b_c&utm_source=AdWords_Brand",
                      },
                      {
                        logo: "makemytrip-logo.jpg",
                        url: "https://www.makemytrip.com",
                      },
                      {
                        logo: "udemy-logo.jpg",
                        url: "https://www.udemy.com",
                      },
                      {
                        logo: "samsung-logo.jpg",
                        url: "https://www.samsung.com",
                      },
                      {
                        logo: "bigrock-logo.png",
                        url: "https://www.bigrock.in",
                      },
                      {
                        logo: "nykaa-logo.jpg",
                        url: "https://www.nykaa.com",
                      },
                    ].map((logo, i) => (
                        <div key={i} className="col-4 col-md-3 p-1">
                          <div className="logo-box border">
                            
                              <img src={`./images/${logo.logo}`} className="logo-img" alt="" onClick={()=>redirecturl(logo.url)} style={{cursor:'pointer'}} />

                          </div>
                        </div>
                      ))}
                  </div>
                </Carousel.Item>
                <Carousel.Item>
                  <div className="row p-2">
                    {[{
                      logo: "oneplus-logo.jpg",
                      url: "https://www.oneplus.in",
                    },
                    {
                      logo: "muscleblaze-logo.jpg",
                      url: "https://www.muscleblaze.com",
                    },
                    {
                      logo: "croma-logo.jpg",
                      url: "https://www.croma.com",
                    },
                    {
                      logo: "lenskart-logo.jpg",
                      url: "https://www.lenskart.com",
                    },
                    {
                      logo: "adidas-logo.jpg",
                      url: "https://www.adidas.co.in",
                    },
                    {
                      logo: "dominos-logo.jpg",
                      url: "https://www.dominos.co.in",
                    },
                    ].map((logo, i) => (
                      <div key={i} className="col-4 col-md-3 p-1">
                        <div className="logo-box border">
                            <img src={`./images/${logo.logo}`} className="logo-img" alt="" onClick={()=>redirecturl(logo.url)} style={{cursor:'pointer'}} />
                        </div>
                      </div>
                    ))}
                  </div>
                </Carousel.Item>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  )
}

export default TopBrandsImages

const Wrapper = styled.section`
  margin: 1.3rem 0px;
  .logo-box {
    height: 75px;
    display: flex;
    align-items: center;     /* vertical center */
    justify-content: center; /* horizontal center */
    background: #fff;
  }

  .logo-img {
    max-width: 80% !important;
    max-height: 100%;
    object-fit: contain;
  }

  .carousel-control-next-icon, .carousel-control-prev-icon {
    background-color: #999898;
    border-radius:50%;
  }

  .carousel-indicators {
        display:none !important;
    }


`